// extracted by mini-css-extract-plugin
module.exports = {"form":"FaqContent_form__Ty0_G","content":"FaqContent_content__PbzfC"};